import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoggerService } from './logger.service';
import { AuthService, Unity4Claim } from '../../auth';
import { finalize, switchMap, take, tap } from 'rxjs/operators';

@Injectable()
export class LoggerInterceptor implements HttpInterceptor {
  constructor(private logger: LoggerService, private authSvc: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.method != 'PUT' && request.method != 'POST') {
      return next.handle(request);
    }

    const started = Date.now();
    let events: any[] = [{ ...request, timestamp: started }];
    let ok: string;

    return this.authSvc.hasClaim$(Unity4Claim.RequestLogging).pipe(
      take(1),
      switchMap((hasClaim) => {
        if (!hasClaim) {
          return next.handle(request);
        }

        return next.handle(request).pipe(
          tap({
            next: (event) => {
              if (event instanceof HttpResponse) {
                ok = 'succeeded';
              }
              events.push({ ...event, timestamp: Date.now() });
            },
            error: (err) => {
              ok = 'failed';
              events.push({ ...err, timestamp: Date.now() });
            },
          }),

          finalize(() => {
            const elapsed = Date.now() - started;
            const msg = `${request.method} "${request.urlWithParams}" ${ok} in ${elapsed} ms.`;
            const headers = request.headers;
            this.logger.debug('LoggerInterceptor', msg, {
              elapsed,
              ok,
              events: events.map((ev) => ({
                ...ev,
                headers: (ev.headers?.keys() || []).reduce(
                  (acc: { [key: string]: string }, key: string) => ({
                    ...acc,
                    [key]: headers.getAll(key),
                  }),
                  {}
                ),
              })),
            })();
          })
        );
      })
    );
  }
}
